import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { FailureToast } from "components/Toast";
import styles from "./brandkit.components.module.scss";

export const MediaErrorMessage = ({ message, onClose }) => {
    return (
      <div className={styles.errorMessage}>
        {message}
        <Button variant="info" onClick={() => onClose()} className={styles.closeIcon}>
          <i className="cleverstory-close" />
        </Button>
      </div>
    )
  }

export const HandleMediaUploadError = ({message, onClose}) => {
    onClose();
    return toast(
      <FailureToast
        heading={`Failure`}
        description={message}
      />,
      {
        type: toast.TYPE.DEFAULT,
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
      }
    );
  }